import { Formula } from '../../lib/types/models/formula/formula'
import { FormulaInput } from '../../lib/types/models/formula/formula-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createFormula(data: FormulaInput) {
  return restApiClient
    .url(constructApiUrl(API.formulas.create.url, null))
    .post<Formula, FormulaInput>(data)
}
